<script setup lang="ts">
import { computed } from 'vue'

import type { StructureTermTreeParagraph } from '../../utils/paragraph-schema/paragraphs'

type TagItemType = StructureTermTreeParagraph['structureTermTree'][number]

const props = defineProps<{
  tagItem: TagItemType
  level: number
}>()

const hasChildren = computed(() => !!(props.tagItem.children && props.tagItem.children.length > 0))

const getModifierClass = (level: number): string => 'bx-tag-list bx-tag-list--level-' + level
</script>

<template>
  <li>
    <template v-if="tagItem.url && tagItem.url.length > 0">
      <a :href="tagItem.url">
        {{ tagItem.name }}
      </a>
    </template>
    <template v-else>
      <span>
        {{ tagItem.name }}
      </span>
    </template>

    <ul v-if="hasChildren"
        :class="getModifierClass(level)">
      <TagItem v-for="item in tagItem.children"
               :key="item.id"
               :tag-item="item"
               :level="(level + 1)" />
    </ul>
  </li>
</template>
